var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckMark = function SvgCheckMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 50 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB81C",
    d: "m47.916 25-5.083-5.792.708-7.666-7.52-1.709-3.938-6.625L25 6.25l-7.084-3.042-3.937 6.625-7.521 1.688.708 7.666L2.083 25l5.083 5.792-.708 7.687 7.52 1.709 3.938 6.624L25 43.75l7.083 3.042 3.938-6.625 7.52-1.709-.708-7.666zM20.833 35.417 12.5 27.083l2.937-2.937 5.396 5.375 13.73-13.73L37.5 18.75z"
  })));
};
export default SvgCheckMark;